export const AUTH_USER = 'auth_user';
export const AUTH_ERROR = 'auth_error';
